"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.s3TransferHandler = void 0;
const aws_client_utils_1 = require("@aws-amplify/core/internals/aws-client-utils");
const composers_1 = require("@aws-amplify/core/internals/aws-client-utils/composers");
const contentSha256middleware_1 = require("../contentSha256middleware");
const xhrTransferHandler_1 = require("../xhrTransferHandler");
/**
 * S3 transfer handler for browser and React Native based on XHR. On top of basic transfer handler, it also supports
 * x-amz-content-sha256 header, and request&response process tracking.
 *
 * @internal
 */
exports.s3TransferHandler = (0, composers_1.composeTransferHandler)(xhrTransferHandler_1.xhrTransferHandler, [
    contentSha256middleware_1.contentSha256MiddlewareFactory,
    aws_client_utils_1.userAgentMiddlewareFactory,
    aws_client_utils_1.amzSdkInvocationIdHeaderMiddlewareFactory,
    aws_client_utils_1.retryMiddlewareFactory,
    aws_client_utils_1.amzSdkRequestHeaderMiddlewareFactory,
    aws_client_utils_1.signingMiddlewareFactory,
]);
